import { render, staticRenderFns } from "./AddTemplateImage.vue?vue&type=template&id=3c0a0088&scoped=true"
import script from "./AddTemplateImage.vue?vue&type=script&lang=js"
export * from "./AddTemplateImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0a0088",
  null
  
)

export default component.exports